import React, { useEffect, useState } from 'react';
import { METRIC_SLUGS, COLORS, METRICS } from './metricsConfig';
import { MetricGraph } from './MetricGraph.jsx';
import { AVERAGE_METRICS, RUBLE_METRIC, PERCENT_METRICS, BONUS_METRIC } from './metricsConfig.js';
import s from './styles/avitoStats.module.css';
import Loader from '../Loader.jsx';
import DateRangeSelector from './DateRangeSelector.jsx'; // импортируем свой новый календарь

const AvitoStats = ({ projectId }) => {
  const [dateRange, setDateRange] = useState([null, null]);
  const [selectedMetric, setSelectedMetric] = useState('');
  const [metricData, setMetricData] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchMetric = async (metricKey, dateFrom, dateTo) => {
    try {
      const response = await fetch('/api/metrika/project', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          project_id: projectId,
          metric: metricKey,
          date_from: dateFrom,
          date_to: dateTo,
        }),
      });

      const result = await response.json();

      if (!response.ok || result.error) {
        throw new Error(result.error || 'Ошибка получения данных');
      }

      return result;
    } catch (error) {
      console.error('⚠️ Ошибка при загрузке метрики:', error.message);
      return {
        actual_date: new Date().toISOString(),
        data: [],
      };
    }
  };

  // const fetchData = async () => {
  //   if (!projectId || !dateRange[0] || !dateRange[1]) return;
  //   setLoading(true);

  //   const from = dateRange[0].toISOString().split('T')[0];
  //   const to = dateRange[1].toISOString().split('T')[0];

  //   const data = await fetchMetric(selectedMetric, from, to);
  //   setMetricData(data);

  //   setLoading(false);
  // };
  const formatDateLocal = (date) => {
    const y = date.getFullYear();
    const m = (date.getMonth() + 1).toString().padStart(2, "0");
    const d = date.getDate().toString().padStart(2, "0");
    return `${y}-${m}-${d}`;
  };

  const fetchData = async () => {
    if (!projectId || !dateRange[0] || !dateRange[1]) return;
    setLoading(true);
  
    const from = formatDateLocal(dateRange[0]);
    const to = formatDateLocal(dateRange[1]);
  
    const data = await fetchMetric(selectedMetric, from, to);

    // ✅ если сервер вернул другую метрику, обновить
    if (!selectedMetric && data.metric) {
      setSelectedMetric(data.metric);
    } else if (data.metric && selectedMetric !== data.metric) {
      setSelectedMetric(data.metric);
    }

    setMetricData(data);
  
    setLoading(false);
  };

  // Авто-подстановка последних 30 дней при первой загрузке
  useEffect(() => {
    const now = new Date();
    const start = new Date();
    start.setDate(now.getDate() - 29);
    setDateRange([start, now]);
    setSelectedMetric('');
  }, [projectId]);

  // Перезапрос при изменении диапазона или метрики
  useEffect(() => {
    if (dateRange[0] && dateRange[1]) {
      fetchData();
    }
  }, [selectedMetric, dateRange]);

  const actualDate =
    metricData?.actual_date
      ? new Date(metricData.actual_date).toLocaleString('ru-RU', {
          day: '2-digit',
          month: 'long',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
        })
      : null;

  return (
    <div className={s.wrapper}>
      <div className={s.filters}>
        <DateRangeSelector value={dateRange} onChange={setDateRange} />

        <select
          value={selectedMetric}
          onChange={(e) => setSelectedMetric(e.target.value)}
          className={s.metricSelect}
        >
          {selectedMetric === '' && !metricData?.metric && (
            <option value="">Выберите метрику</option>
          )}
          {Object.entries(METRICS).map(([key, label]) => (
            <option key={key} value={key}>
              {label}
            </option>
          ))}
        </select>

        {actualDate && <div className={s.actualDate}>Актуально: {actualDate}</div>}
      </div>

      {loading ? (
        <Loader />
      ) : (
        metricData && (
          <MetricGraph
            label={METRICS[selectedMetric] || (METRICS[metricData?.metric] || 'Нет данных.')}
            data={metricData.data}
            color={COLORS[selectedMetric] || COLORS[metricData?.metric]}
            average={AVERAGE_METRICS[selectedMetric] || AVERAGE_METRICS[metricData?.metric]}
            ruble={RUBLE_METRIC[selectedMetric] || RUBLE_METRIC[metricData?.metric]}
            bonus={BONUS_METRIC[selectedMetric] || BONUS_METRIC[metricData?.metric]}
            percent={PERCENT_METRICS[selectedMetric] || PERCENT_METRICS[metricData?.metric]}
            totalConversion={metricData.total_conversion}
            total = {metricData.total}
            slave_metrica = {metricData.slave_metrica}
            slave_total  = {metricData.slave_total}

          />
        )
      )}
    </div>
  );
};

export default AvitoStats;
